"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translationsFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dictionary_evidence_1 = require("../../composite/evidence/dictionary-evidence/dictionary-evidence");
const evidence_1 = require("../../composite/evidence/evidence");
const translations_schema_1 = require("./translations-schema");
const translations_columns_1 = require("./translations-columns");
const translations_fields_1 = require("./translations-fields");
function translationsFactory(url, reportTag) {
    return function Translations() {
        const intl = react_intl_1.useIntl();
        const validationSchema = translations_schema_1.useValidationSchema();
        const evidence = dictionary_evidence_1.useDictionaryEvidence({
            identifier: 'TRANSLATIONS',
            apiProps: {
                url,
            },
            tableProps: {
                columns: translations_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'EAS_TRANSLATIONS_TABLE_TITLE',
                    defaultMessage: 'Překlady',
                }),
                reportTag,
            },
            detailProps: {
                FieldsComponent: translations_fields_1.TranslationsFields,
                validationSchema,
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.translationsFactory = translationsFactory;
//# sourceMappingURL=translations.js.map